import type {Result, UseCase} from 'framework';
import type {DailyDashboard} from '../../domain/daily-dashboard';
import type {LocalDate} from '../../domain/local-date.value-object';
import type {DashboardError} from '../../domain/errors';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface GetDailyDashboardInput {
  readonly date: LocalDate | null;
}

/**
 * Loads the daily dashboard for the resolved date. The use-case is a thin
 * pass-through today; centralising it here keeps the controller free of
 * repository imports and gives us a place to add cross-cutting policy
 * later (caching, analytics, retry).
 */
export class GetDailyDashboard implements UseCase<[GetDailyDashboardInput], DailyDashboard> {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  execute(input: GetDailyDashboardInput): Promise<Result<DailyDashboard, DashboardError>> {
    return this.dashboardRepository.fetchDaily({date: input.date});
  }
}
